import { render } from "./ConfirmAccountContainer.vue?vue&type=template&id=0c7c3d69"
import script from "./ConfirmAccountContainer.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__